import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useParams, useNavigate } from 'react-router-dom';


import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";


function ServiceDetail() {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);


    const [ProjectDetails, setProjectDetails] = useState(null);
    const [ProjectName, setProjectName] = useState("");
    const [ServiceType, setServiceType] = useState("");
    const [loading, setLoading] = useState(true);
    const [projectImages, setProjectImages] = useState([]);
    const [projectMainImages, setProjectMainImages] = useState([]);

    
    console.log(slug)
    const fetchProductDetails = async () => {
        setLoading(true);

        try {
            const response = await fetch(
                `https://crmradius.gemsdrive.co.uk/public/api/get_project_details/${slug}`
            );
            if (!response.ok) {
                navigate("/NotFound");
                return;
            }
            const result = await response.json();
            const project = result?.project?.[0];
            console.log("🔍 Fetched Project Details:", project);
            if (!project) {
               // navigate("/NotFound");
                return;
            }

            setProjectDetails(project?.description ?? null);
            setProjectName(project?.project_name ?? "");
            setServiceType(project?.service_name ?? "");
            setProjectMainImages(project?.main_img ?? "");
            const images =
                project?.multiple_images
                    ? project.multiple_images.split(",")
                    : [];
            setProjectImages(images);
        } catch (error) {
            console.error("❌ Error fetching Project details:", error);
            navigate("/NotFound");
        } finally {
            setLoading(false);
        }
    };
    console.log(projectMainImages);
    // ✅ Now HOOK is OUTSIDE
    useEffect(() => {
        fetchProductDetails();
    }, [slug]);

    // ✅ LOADING UI
    if (loading) {
        return <p className="text-center mt-5">Loading...</p>;
    }

    // ✅ NO DATA FOUND
    if (!ProjectDetails) {
        return <p className="text-center mt-5 text-danger">No details found.</p>;
    }
    return (
        
        <>
             
            <Helmet>
                <title>Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company | {ProjectName}</title>
                <meta name="description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
                <meta property="og:title" content="Radius - Career Details" />
                <meta property="og:description" content="Radius Exhibition Fixtures &#8211; Interior Fit Out Company in Dubai, UAE | Signage Company" />
            </Helmet>

            <Header />

            <main role="main" className="main">

                {/* ======= PAGE HEADER ======= */}
                {/* <section className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7">
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center p-static order-2 text-center">
                                <h1 className="text-10">
                                    <strong>{ProjectName}</strong>
                                </h1>
                            </div>
                            <div className="col-md-12 align-self-center order-1">
                                <ul className="breadcrumb breadcrumb-light d-block text-center">
                                   
                                </ul>
                            </div>
                        </div>
                    </div>
                </section> */}

                <section
                    className="page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-7"
                    style={{
                        // backgroundImage: ``,
                        backgroundImage: `url(https://crmradius.gemsdrive.co.uk/main_image/${projectMainImages})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    <div className="container">
                        <div className="row mt-5">
                            <div className="col-md-12 align-self-center p-static order-2 text-center">
                                <h1 className="text-10 text-white">
                                    <strong>{ProjectName}</strong>
                                </h1>
                            </div>

                            <div className="col-md-12 align-self-center order-1">
                                <ul className="breadcrumb breadcrumb-light d-block text-center"></ul>
                            </div>
                        </div>
                    </div>
                </section>
                <hr className="m-0" />
                <div className="container py-4">

                    <div className="row">
                        <div className="col" style={{ minHeight: "250px" }}>

                            <div className="row mt-4">
                                {projectImages.map((img, index) => (
                                    <div key={index} className="col-12 col-sm-6 col-lg-3 mb-4">
                                        <img
                                            src={`https://crmradius.gemsdrive.co.uk/main_image/${img}`}
                                            className="img-fluid rounded shadow-sm cursor-pointer"
                                            alt={`Project ${index + 1}`}
                                            onClick={() => {
                                                setPhotoIndex(index);
                                                setOpen(true);
                                            }}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Lightbox */}
                            <Lightbox
                                open={open}
                                close={() => setOpen(false)}
                                index={photoIndex}
                                slides={projectImages.map(img => ({
                                    src: `https://crmradius.gemsdrive.co.uk/main_image/${img}`
                                }))}
                                plugins={[Zoom, Thumbnails]}
                            />
                        </div>
                    </div>
                    <div className="row pt-4 mt-2 mb-5">
                        <div className="col-md-12 mb-4 mb-md-0">

                            <div
                                className=" text-start"
                                dangerouslySetInnerHTML={{ __html: ProjectDetails }}
                            />

                        </div>
                         
                    </div>

                </div>

            
               
            </main>
            <Footer />
        </>
    );
}

export default ServiceDetail;
